module.exports = __webpack_public_path__ + "img/1280x720-Business.d10fc873.jpg";